import React from 'react';
import CrudTable from '../../components/common/CrudTable';
import { aboutUsAPI } from '../../api/services';

const COLUMNS = [
  { key: 'title', label: 'Title' },
  { key: 'text', label: 'Text', render: (item) => item.text?.length > 60 ? item.text.substring(0, 60) + '...' : item.text },
  { key: 'mediaUrl', label: 'Image', render: (item) => item.mediaUrl ? <img src={item.mediaUrl} alt="" style={{ width: 48, height: 32, objectFit: 'cover', borderRadius: 6 }} /> : '—' },
];

const FORM_FIELDS = [
  { name: 'title', label: 'Title', placeholder: 'Our Mission' },
  { name: 'text', label: 'Content', type: 'textarea', placeholder: 'Write about us...' },
  { name: 'mediaId', label: 'Section Image', type: 'file' },
];

const AboutUsAdmin = () => (
  <CrudTable
    title="About Us"
    entityName="About Us Entry"
    columns={COLUMNS}
    formFields={FORM_FIELDS}
    fetchData={async () => {
      const res = await aboutUsAPI.getAll();
      return res.data?.data || [];
    }}
    onAdd={(data) => aboutUsAPI.add(data)}
    onUpdate={(id, data) => aboutUsAPI.update(id, data)}
    onDelete={(id) => aboutUsAPI.delete(id)}
  />
);

export default AboutUsAdmin;
